const doc = [({"en":({"js":({"admin":({"reimbursement_attachments":({"expandable_content":({"description":({"number_of_characters":"Number of characters"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;